import React, { Component } from "react";
import { Box, Flex, Menu, Spacer, MenuButton, MenuItem, MenuList, MenuDivider, Button, Image, Text, Tag, TagLabel, HStack } from '@chakra-ui/react';
import GlassbitLogo from "../../../assets/images/logos/glasschain-logo.png";

import "../../../assets/css/navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapPin, faBars, faSatelliteDish, faWifi, faPlane, faGear, faHeartbeat, faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import ConfigService from "../../../services/ConfigService";
import CoreService from "../../../services/CoreService";

import RoleManager from "../../../models/RoleManager";
import { AppSecurityKey } from "../../../models/AppSecurityKey";
import "../../../assets/css/timer.css";
import ExpirationTimer from "./ExpirationTimer";
import ModalIdNameListDialog from "../../../components/Modals/ModalIdNameListDialog";

import { HealthStatusType } from "../../../models/HealthStatusType";


function Animate({ children, on }) {
    return (on === undefined)
        ? <div>{children}</div>
        : <div className="satelliteanim" key={on}>{children}</div>
}


export default class Navbar extends Component {
    constructor(props) {
        super(props);
        this.configService = new ConfigService();
        this.coreService = new CoreService();
        this.state = {
            isDrawerOpen: false,
            customerLogoImgSrc: "",
            healthColor: "lightgreen",

        }
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.onModalOpenRequest = this.onModalOpenRequest.bind(this);
        this.onModalCloseRequest = this.onModalCloseRequest.bind(this);
        this.onModalOkRequest = this.onModalOkRequest.bind(this);


    }

    async componentDidMount() {
        let customerLogoImgSrc = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);
        this.setState({
            customerLogoImgSrc: customerLogoImgSrc
        });
    }

    async componentDidUpdate(prevProps)
    {
        if (prevProps.healthInfoTriggerKey != this.props.healthInfoTriggerKey)
        {
            var overallHealth = (this.props.healthInfo) ? this.props.healthInfo.overallStatus() : HealthStatusType.UNKNOWN;
            var healthColor = (overallHealth == HealthStatusType.OK) ? "lightgreen" :
                (overallHealth == HealthStatusType.WARNING) ? "yellow" : "red";
            this.setState({healthColor: healthColor});
        }
        if (prevProps.onlineStatusChangeKey != this.props.onlineStatusChangeKey)
        {
            // used to inform system of change that may not be caught because props.onlineInfo is not a primitive
        }
    }


    toggleDrawer() {
        this.setState({
            isDrawerOpen: !this.state.isDrawerOpen
        })
    }


    onModalOpenRequest(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.props.userSession.locations.length < 2) {
            alert("You have no Locations to change to!")
            return;
        }
        this.setState({ showModal: true });
    }

    onModalCloseRequest(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({ showModal: false });
    }

    async onModalOkRequest(existingValue, newValue) {
        this.props.onCurrentLocationIdUpdateRequest(newValue);
        this.onModalCloseRequest();
        //await this.refreshData();
    }


    render() {

        var gcidLogo = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);

        var currentLocation = (this.props.userSession.locations) ? this.props.userSession.locations.find((l) => l.id === this.props.currentLocationId) : { id: "", name: "" };
        var existingLocationLabel = (currentLocation) ? currentLocation.name + " [" + currentLocation.id + "]" : "";
        var hasEntityManagementRights = RoleManager.hasRoleRights(AppSecurityKey.EDIT_ENTITIES, this.props.userSession.token);

        return (
            <div className={(this.props.isVisible) ? "navbar" : "navbar-hidden"}>

                <ModalIdNameListDialog
                    id="locationsdialog"
                    show={this.state.showModal}
                    title="Inspection Location"
                    placeholder="Inspection Location"
                    onModalCloseRequest={this.onModalCloseRequest}
                    onModalOkRequest={this.onModalOkRequest}
                    existingValue={currentLocation}
                    dataList={this.props.userSession.locations}
                />



                <Flex w='100vw' justify={'space-between'} alignItems='center' maxH='10vh'>
                    <Image
                        src={GlassbitLogo}
                        alt="Customer Logo"

                        fit='scale-down'
                        marginLeft={'20px'}
                        boxSize='4vw'
                    />
                    <Text
                        fontSize={{ base: '10px', md: '16px', lg: '24px' }}
                        marginTop='3vh'
                    >
                        Glasschain Observations
                    </Text>

                    <Spacer />
                    <Box className="image-container">
                    <Image src={gcidLogo}
                        alt="Customer Logo"
                        objectFit='scale-down'
                        boxSize='10vw'
                    />
                    </Box>
                    <Spacer />
                    <HStack alignItems='baseline'>
                        <Box p='2'>
                            <Tag id='locationbtn' onClick={e => this.onModalOpenRequest(e)} >
                                <FontAwesomeIcon icon={faGear} style={{ marginRight: "5px", color: 'white' }} />
                                <TagLabel style={{ color: 'white' }}>{existingLocationLabel}</TagLabel>
                            </Tag>
                            <ExpirationTimer
                                expires={this.props.sessionExpiration}
                                alertSecondsLeft={this.props.alertSecondsLeft}
                                expireSecondsLeft={this.props.expireSecondsLeft}
                                onExpiredToken={this.props.onExpiredToken}
                                onlineInfo={this.props.onlineInfo}
                            />
                            
                            <Tag id='offlineCounter' onClick={(e) => this.props.onPurgeOfflineObservationsRequest(this.props.inQueueCount)}>
                                <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: "5px", color: (this.props.inQueueCount > 0) ? 'green' : 'grey' }} />
                                <TagLabel style={{ color: (this.props.inQueueCount > 0) ? 'green': 'lightgrey' }}>{this.props.inQueueCount}</TagLabel>
                            </Tag>
                        </Box>
                        <Box p='2'>
                            <Flex direction='column'>
                                <Text style={{ margin: "0" }}>{this.props.userSession.uid}</Text>
                                <HStack>
                                    {this.props.inObservationSession && <FontAwesomeIcon icon={faMapPin} color={(this.props.isGeolocationEnabled && this.props.onlineInfo.isConnected) ? "green" : "grey"} />}
                                        <Tag id='airplanemodebtn'>
                                            <FontAwesomeIcon icon={faPlane} color={(this.props.onlineInfo.isAirplaneMode === true) ? "lightgreen" : "white"} onClick={(e) => this.props.onToggleAirplaneModeRequest(e)} />&nbsp; 
                                        </Tag>
                                        <FontAwesomeIcon icon={faWifi} color={(this.props.onlineInfo.isOnline) ? "lightgreen": "grey"} />&nbsp;
                                        <FontAwesomeIcon icon={faHeartbeat} color={this.state.healthColor} />
                                    <Animate on={this.props.lotWatcherRunning}>
                                            <FontAwesomeIcon icon={faSatelliteDish} color={(this.props.lotWatcherRunning) ? "green" : (this.props.autoRefresh) ? "lightgreen" : "red"} />
                                    </Animate>

                                </HStack>                          
                            </Flex>
                        </Box>
                    </HStack>
                    {/* <Spacer></Spacer> */}
                    <Box p='3'>
                        <Menu>
                            <MenuButton as={Button} >
                                <FontAwesomeIcon icon={faBars} color="white" />
                            </MenuButton>
                            <MenuList>
                                <MenuItem color="black" onClick={(e) => this.props.onHomePageRequest(this.props.userSession.token)}>Home</MenuItem>
                                <MenuDivider />
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.VIEW_DASHBOARD, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onDashboardPageRequest()}>Dashboard</MenuItem>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.DATA_API_ACCESS, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onDataApiInstructionsPageRequest()}>Data API Access</MenuItem>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.VIEW_SCHEMAS, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onSchemaManagementPageRequest()}>Schema Viewer</MenuItem>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.VIEW_ORGCONFIG, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onOrgConfigManagementPageRequest()}>Org Config Viewer</MenuItem>

                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.EDIT_ENTITIES, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onEntityManagementPageRequest()}>Lookup Entity Management</MenuItem>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.EDIT_DATALISTS, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onDataManagementPageRequest()}>Data Management</MenuItem>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.EDIT_USERS, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onUserManagementPageRequest()}>User Management</MenuItem>
                                <MenuItem color="black" isDisabled={!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token)} onClick={(e) => this.props.onSubscriberManagementPageRequest()}>Event Subscriber Management</MenuItem>
                                <MenuDivider />
                                <MenuItem color="black" isDisabled={(!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onLogoutRequest()}>Log Out</MenuItem>
                                <MenuItem color="black" onClick={(e) => this.props.onUserGuideRequest()}>User Guide</MenuItem>
                                <MenuItem color="black" onClick={(e) => this.props.onAboutOpen(e)}>About</MenuItem>
                                <MenuItem color="black" onClick={(e) => this.props.onChangeHistoryPageRequest(e)}>Change History</MenuItem>



                            </MenuList>
                        </Menu>
                    </Box>
                </Flex>
            </div>
        )
    }
}